import { getRawModuleDataFromResponse } from '../../../utils/modules';
import { getShopWidgetConfigs } from '../../components/Sections/ShopSection/shopWidgetConfigs';
import { FILTER_QUERYSTRING_KEYS } from '../../components/Sections/ShopSection/_partials/ShopGridWithFilters/ShopFilters/constants';
import { setTotalPages, setCurrentPage, setRequestParams, setStats } from '../../actions/pageInfo';
import { getCustomInitActionsForWidgets, getRawSectionModules, getModuleData } from './common';

/** these are the request parameters in the frontend that get passed to the backend papi call */
export const SHOP_PARAMS_SENT_TO_PAPI = [
  ...FILTER_QUERYSTRING_KEYS,
  'q',
  'order',
  'page',
  'deviationid',
];

export function getShopPageInfoInitActions(responseData, requestParams) {
  return [
    ...getShopCurrentPageInitActions(responseData, requestParams),
    ...getShopTotalPageInitActions(responseData, requestParams),
    setRequestParams(requestParams),
    getShopStatsInitAction(responseData),
  ];
}

/** set the shop's currentPage from the request params */
function getShopCurrentPageInitActions(responseData, requestParams) {
  const currentPage = requestParams.page ? parseInt(requestParams.page, 10) : 1;
  return [setCurrentPage(currentPage)];
}

function getShopStatsInitAction(responseData) {
  return setStats(responseData?.pageExtraData?.stats);
}

/** set the totalPages of the current stream of shop products (if any) */
function getShopTotalPageInitActions(responseData, requestParams) {
  // note that if we try this in the individual shop product module
  // inits in modules.ts, they will overwrite each other since the
  // `totalPages` are shared between them
  const { shop_section } = requestParams;
  if (!shop_section) {
    return [];
  }

  const modules = getRawSectionModules(responseData);
  // [special case] we had a rename from adoptables to exclusives here:
  // the url was updated but the module name stayed the same
  const moduleName = shop_section === 'exclusives' ? 'adoptables' : shop_section;
  const shopSectionModule = getModuleData(modules, moduleName);
  if (!shopSectionModule) {
    return [];
  }

  const moduleData = shopSectionModule.dataKey
    ? getRawModuleDataFromResponse(shopSectionModule)
    : shopSectionModule;
  const { totalPageCount } = moduleData;
  return totalPageCount === 0 || totalPageCount ? [setTotalPages(totalPageCount)] : [];
}

// new grusers
export const getCustomInitActionsForShopWidgets = (responseData, requestParams) => [
  ...getCustomInitActionsForWidgets(
    responseData,
    requestParams,
    getShopWidgetConfigs({
      t: () => null,
      dispatch: () => null,
    })
  ),
  ...getShopPageInfoInitActions(responseData, requestParams),
];
